import { FaChevronDown } from 'react-icons/fa';

export const SelectControl = ({ children }) => (
  <div className="custom-select-wrapper">
    {children}

    <FaChevronDown className="chevron" />
  </div>
);
